import { formatUsd } from './conversationSpend';

export type CreditsRow = { label: string; value: string };

// The total sums only the fetched page of sessions, so a capped list says which page.
const creditsRows = ({
  conversationSpend,
  allConversationsSpend,
  sessionCount,
  sessionsCapped,
}: {
  conversationSpend: number | null;
  allConversationsSpend: number;
  sessionCount: number;
  sessionsCapped: boolean;
}): [CreditsRow, CreditsRow] => [
  {
    label: 'This conversation',
    value: conversationSpend === null ? '-' : formatUsd(conversationSpend),
  },
  {
    label: sessionsCapped ? `Latest ${sessionCount} conversations` : 'All conversations',
    value: formatUsd(allConversationsSpend),
  },
];

export default creditsRows;
